import React from "react";
import "./ProgramAndProjectManagement.css";
import ProgramAndProjectOverview from "./ProgramAndProjectOverview";
import BannerImage from "../../../assets/other_image/Teamcenter_project_management.jpg";
import Letsgetintouch from "../BusinessProcessAndChangeManagement/Letsgetintouch";
import { NavLink } from "react-router-dom";
import Banner from "../Banner/Banner";
import FloatingContactUs from "../../floting_contact/FloatingContactUs";
import { Helmet } from "react-helmet-async";

const ProgramAndProjectManagement = () => {
  return (
    <>
      {/* ✅ Meta Tags for SEO */}
      <Helmet>
        <title>
          Teamcenter Program & Project Management Solutions in Pune | NexTech PLM
        </title>
        <meta
          name="description"
          content="Streamline your product development with NexTech PLM's Teamcenter-based program and project management solutions. Achieve seamless planning, real-time tracking, and efficient execution across the product lifecycle."
        />
        <meta
          name="robots"
          content="index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1"
        />
      </Helmet>

      <section className="ProgramAndProject-management">
        <Banner
          image={BannerImage} // Pass the image for this page
          heading="Teamcenter Project Management" // Pass the heading text for this page
        />
        <div>
          <FloatingContactUs />
        </div>

        <ProgramAndProjectOverview />

        <section style={{ background: "#f5f7fa" }}>
          <div className="benefits container">
            <h4 className="ProgramAndProject-page-heading">Unlock the Power :</h4>
            <h5 className="ProgramAndProject-subheading">
              Discover the Transformative Benefits of Teamcenter Project Management with
              NexTech!
            </h5>
            <ul className="custom-bullets">
              <li>Planning against accurate requirements and goal </li>
              <li>
                Real-time visibility into the status and the deliverables being executed
              </li>
              <li>Everyone has exactly what they need to get their tasks completed</li>
              <li>Project status automatically updates as work is completed </li>
              <li>Ensure visibility across projects, domains, and the lifecycle </li>
            </ul>
          </div>
        </section>

        <section>
          <div className="solutions container">
            <div className="solutions-content">
              <div className="row">
                <div className="col-md-6 col-12">
                  <h4 className="ProgramAndProject-page-heading">
                    Teamcenter Solutions
                  </h4>
                  <p className="plmimplementationparagraph">
                    Support a top-down approach to program planning, determining what should
                    be executed, with a bottom-up approach that validates what can be
                    executed given your resources, timelines, and more. With program
                    planning inside PLM, you can plan against accurate requirements and
                    goals. You can be assured the program status is always in sync with
                    what’s being executed. You can see what’s happening in real-time
                    dashboard views. Ensure visibility across projects, domains, and the
                    lifecycle Program management solutions provide planning and execution
                    in the same system
                  </p>
                  <ul className="custom-bullets">
                    <li>Schedule Management </li>
                    <li>Program Management </li>
                    <li>Portfolio Management </li>
                    <li>Project Management </li>
                  </ul>
                </div>

                <div className="col-md-6 col-12">
                  <div className="quick-links">
                    <h4>Quick Links</h4>
                    <ul>
                      <li>
                        <NavLink to="/teamcenter-ecad-integration">
                          ECAD Integration
                        </NavLink>
                      </li>
                      <li>
                        <NavLink to="/teamcenter-mcad-integration">
                          MCAD Integration
                        </NavLink>
                      </li>
                      <li>
                        <NavLink to="/teamcenter-cybersecurity">
                          Teamcenter Cyber security
                        </NavLink>
                      </li>
                      <li>
                        <NavLink to="/teamcenter-manufacturing-data-process-management">
                          Manufacturing Data and Process Management
                        </NavLink>
                      </li>
                      <li>
                        <NavLink to="/teamcenter-plm-erp-data-process-management">
                          PLM - ERP (SAP, Oracle, HANA) Data and Process
                          Management
                        </NavLink>
                      </li>
                      <li>
                        <NavLink to="/teamcenter-bom-management">
                          Product BOM and Variability Management
                        </NavLink>
                      </li>
                      <li>
                        <NavLink to="/teamcenter-upgrade-migration">
                          Teamcenter Upgrade & Migration
                        </NavLink>
                      </li>
                      <li>
                        <NavLink to="/teamcenter-business-process-management">
                          Business Processes & Change Management
                        </NavLink>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section style={{ background: "#f5f7fa" }}>
          <div className="why-nextech container">
            <h4 className="ProgramAndProject-page-heading">Why NexTech?</h4>
            <h5 className="ProgramAndProject-subheading">
              For Program and Project Management
            </h5>
            <ul className="custom-bullets">
              <li>
                Integrated Solution: NexTech offers an integrated program and project
                management solution that allows planning, management, and execution of
                projects in one centralized platform.
              </li>
              <li>
                Real-Time Visibility: Our solution provides real-time visibility into
                project status and deliverables, ensuring accurate tracking of progress
                and alignment with goals.
              </li>
              <li>
                Seamless PLM Integration: With NexTech, you can directly connect PLM data,
                such as parts, documents, and requirements, to project tasks and
                deliverables, ensuring that everyone has access to the necessary resources
                for task completion.
              </li>
              <li>
                Top-Down and Bottom-Up Approach: Our solution supports both top-down
                program planning and bottom-up validation, allowing for comprehensive
                planning against accurate requirements and goals.
              </li>
              <li>
                Easy-to-Use Tools: NexTech offers user-friendly project management tools
                suitable for both project management experts and non-experts, ensuring
                efficient project execution regardless of complexity.
              </li>
            </ul>
          </div>
        </section>
        <Letsgetintouch />
      </section>
    </>
  );
};

export default ProgramAndProjectManagement;
